import { render, staticRenderFns } from "./ApprovalDash.vue?vue&type=template&id=180ac2a0&"
import script from "./ApprovalDash.vue?vue&type=script&lang=js&"
export * from "./ApprovalDash.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalDash.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports